// @ts-nocheck

import React, { useState, useEffect } from 'react';

import { getGooglePlayStoreAppData, getIosAppStoreAppData } from '../services/ExternalAppStore';

export const APPLE = 'apple';
export const ANDROID = 'android';

function useExternalAppStoreData({ appId, country, store }) {
  const [appData, setAppData] = useState({});
  const [error, setError] = useState(null);

  function getAppData() {
    function _getAppData() {
      if (store === APPLE) {
        return getIosAppStoreAppData({ id: appId, country });
      }
      return getGooglePlayStoreAppData({ id: appId });
    }

    _getAppData()
      .then((data) => {
        if (!data || !data.name) {
          return setError('app data not found');
        }
        setAppData(data);
      })
      .catch((e) => {
        setError(e);
      });
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: ignored using `--suppress`
  useEffect(getAppData, [appId, country, store]);

  return { appData, error };
}

export default useExternalAppStoreData;
